import _ from 'underscore';

class ModalStack {
    constructor() {
        this.modalArray = [];
        this.index = 0;
    }

    addModel(modal) {
        this.modalArray.push(modal);
    }

    addModals(modals) {
        this.modalArray = modals;
    }

    iterate() {
        var realButtonClicked = this.modalArray[this.index].onSaveButtonClicked;
        this.modalArray[this.index].onSaveButtonClicked = function() {
            var retVal = realButtonClicked();
            if (this.index < this.modalArray.length - 1) {
                this.modalArray[this.index].postRemove = () => {
                    this.iterate();
                };
            }
            this.index++;
            return retVal;
        }.bind(this);
        this.modalArray[this.index].render();
    }
}

export default ModalStack;
